import React from "react";

import LoginForm from "./Components/FormControl/LoginForm";

import AuthLayout from "@/Components/Layouts/Native/AuthLayout";

function LoginScreen(): React.JSX.Element {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
}

export default LoginScreen;
